<template>
  <span>
    <!-- on -->
    <b-dropdown
      split-variant="outline-primary"
      variant="primary"
      :text="selectedDate.date | niceDate"
      class
    >
      <b-dropdown-item
        @click="updatePrefferedShippingDate(run)"
        :key="index"
        v-for="(run,index) in shipping_days"
      >{{ run.date | niceDate }}</b-dropdown-item>
    </b-dropdown>
  </span>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'profile-shipping-run',
    props: {
        blok: Object
    },
    data: () => {
        return {
            shipping_days: []
        }
    },
    methods: {
        ...mapActions("recipes", ["getLatestShippingRuns"]),
        ...mapActions("profile", ["updatePrefferedShippingDate"]),
    },
    mounted: function() {
        const b = this.$props.blok;
        this.getLatestShippingRuns().then(data => {
            data.map( v => {
                this.shipping_days.push({
                    date: v.delivery_days.day_1,
                    day: 'day_1',
                    id: v.id
                });
                this.shipping_days.push({
                    date: v.delivery_days.day_2,
                    day: 'day_2',
                    id: v.id
                })
            });
            if(this.meal_preferences.shipping_date==null) {
                this.updatePrefferedShippingDate(this.shipping_days[0])
            }
            this.shipping_days = this.shipping_days.slice(0,9)
        });
    },
    computed: {
        ...mapState({
            meal_preferences: state => state.profile.meal_preferences
        }),
        selectedDate: function() {
            return this.meal_preferences.shipping_date || this.shipping_days[0] || { date: '1-1-99'};
        }
    }
}
</script>
